// Swiper
import Swiper from 'swiper';
import {
  EffectCreative,
  EffectFade,
  Navigation as SwiperNavigation,
  Pagination as SwiperPagination,
} from 'swiper/modules';
Swiper.use([EffectCreative, EffectFade, SwiperNavigation, SwiperPagination]);

// Core
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

// Slider
function customerCasesInit() {
  const customerCasesSliderOptionsBase = {
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    preventClicks: true,
    preventClicksPropagation: true,
  };
  const customerCasesSliderOptionsSm = {
    effect: 'slide',
    allowTouchMove: true,
    navigation: false,
    noSwiping: false,
    slidesPerGroupAuto: true,
    slidesPerView: 'auto',
    spaceBetween: 12,
    speed: 300,
  };
  const customerCasesSliderOptionsMd = {
    effect: 'creative',
    creativeEffect: {
      prev: {
        translate: ['-15%', 0, -1000],
      },
      next: {
        translate: ['104%', 0, 0],
      },
      limitProgress: 1,
    },
    allowTouchMove: false,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
    noSwiping: true,
    slidesPerGroupAuto: false,
    slidesPerView: 2,
    breakpoints: {
      // Necessary for proper sizes calculation after resize
      861: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
    spaceBetween: 20,
    speed: 300,
    watchSlidesProgress: true, // for .swiper-slide-visible
  };

  let customerCasesSlider = null;

  const handleCustomerCasesSliderInit = () => {
    if (customerCasesSlider) {
      customerCasesSlider.destroy();
    }

    const options = mediaSm.matches ? customerCasesSliderOptionsSm : customerCasesSliderOptionsMd;

    customerCasesSlider = new Swiper('#customer-cases-slider', Object.assign(customerCasesSliderOptionsBase, options));
  };

  handleCustomerCasesSliderInit();
  mediaSm.addEventListener('change', handleCustomerCasesSliderInit);
}

export default customerCasesInit;
